import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import {
  EstimateExportPdf,
  HomeownerChangeOrderPdf,
  ProjectItemScopeOfWorkPdf,
  ScheduleExportPdf,
  ScheduleOfValuesPdf,
} from "src/routes/pdfs";
import { BillPdf } from "src/routes/pdfs/BillPdf/BillPdf";
import { CommitmentOrChangeOrderPdf } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/CommitmentOrChangeOrderPdf";
import { DevelopmentCommitmentPdf } from "src/routes/pdfs/DevelopmentCommitmentPdf";
import { DevelopmentContractPdf } from "src/routes/pdfs/DevelopmentContractPdf/DevelopmentContractPdf";
import { FinishScheduleVisualModePdf } from "src/routes/pdfs/FinishSchedulePdf/FinishScheduleVisualModePdf";
import { InvoicePandaDocPdf } from "src/routes/pdfs/InvoicePdf/InvoicePandaDocPdf";
import { InvoicePdf } from "src/routes/pdfs/InvoicePdf/InvoicePdf";
import { LienWaiverRouter } from "src/routes/pdfs/LienWaiverPdf/LienWaiverRouter";
import { ProjectFinishSchedulePdf } from "src/routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishSchedulePdf";
import { ProjectFinishScheduleVisualModePdf } from "src/routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishScheduleVisualModePdf";
import { ToDosPdf } from "src/routes/pdfs/ToDosPdf";
import { TradeScopeOfWorkPdf } from "src/routes/pdfs/TradeScopeOfWorkPdf";
import { TradeSpecificAgreement } from "src/routes/pdfs/TradeSpecificAgreement";
import { TradesPunchlistPdf } from "src/routes/pdfs/TradesPuchlistPdf/TradesPunchlistPdf";
import { LotSequenceSheetPdf } from "src/routes/pdfs/lot-sequence-sheet/LotSequenceSheetPdf";
import { LotSummaryDetailsPdf } from "src/routes/pdfs/lot-summary-details/LotSummaryDetailsPdf";
import {
  bidCommitmentChangeOrderPdfPath,
  bidCommitmentPdfPath,
  billPdfPath,
  commitmentChangeOrderPdfPath,
  commitmentPdfPath,
  developmentCommitmentPdfPath,
  developmentContractPdfPath,
  estimateExportPath,
  finishScheduleVisualModePdfPath,
  homeownerChangeOrderPath,
  invoicePandaDocPdfPath,
  invoicePdfPath,
  lienWaiverPdfPath,
  lotSequenceSheetPdfPath,
  lotSummaryDetailsPdfPath,
  projectFinishSchedulePdfPath,
  projectFinishScheduleVisualModePdfPath,
  projectItemScopeOfWorkPath,
  scheduleExportPath,
  scheduleOfValuesPath,
  toDoPdfPath,
  tradeScopeOfWorkPath,
  tradeSpecificAgreementPath,
  tradesPunchlistPdfPath,
} from "src/routes/routesDef";
import { PdfLayout } from "src/routing/components/layouts/PdfLayout";

/**
 * `/pdf/*` route tree for HTML-to-PDF pages.
 *
 * Role: data router domain route.
 *
 * Stack: `PdfLayout` → page. Not wrapped in `AppShell` because the headless "save HTML as PDF"
 * browser uses an `Authorization` header instead of Amplify-managed auth.
 *
 * Path constants live in `routesDef.ts` (absolute `/pdf/...` strings, including `/*` splats).
 */
export const pdfRoutes: RouteObject[] = [
  {
    Component: PdfLayout,
    children: [
      { path: scheduleOfValuesPath, Component: ScheduleOfValuesPdf },
      { path: projectItemScopeOfWorkPath, Component: ProjectItemScopeOfWorkPdf },
      { path: tradeScopeOfWorkPath, Component: TradeScopeOfWorkPdf },
      { path: homeownerChangeOrderPath, Component: HomeownerChangeOrderPdf },
      { path: estimateExportPath, Component: EstimateExportPdf },
      { path: scheduleExportPath, Component: ScheduleExportPdf },
      { path: `${tradeSpecificAgreementPath}/*`, Component: TradeSpecificAgreement },
      { path: `${developmentCommitmentPdfPath}/*`, Component: DevelopmentCommitmentPdf },
      { path: `${commitmentPdfPath}/*`, Component: CommitmentOrChangeOrderPdf },
      { path: `${commitmentChangeOrderPdfPath}/*`, Component: CommitmentOrChangeOrderPdf },
      { path: bidCommitmentPdfPath, Component: CommitmentOrChangeOrderPdf },
      { path: bidCommitmentChangeOrderPdfPath, Component: CommitmentOrChangeOrderPdf },
      { path: toDoPdfPath, Component: ToDosPdf },
      { path: developmentContractPdfPath, Component: DevelopmentContractPdf },
      { path: lotSequenceSheetPdfPath, Component: LotSequenceSheetPdf },
      { path: lotSummaryDetailsPdfPath, Component: LotSummaryDetailsPdf },
      { path: billPdfPath, Component: BillPdf },
      { path: invoicePandaDocPdfPath, Component: InvoicePandaDocPdf },
      { path: invoicePdfPath, Component: InvoicePdf },
      { path: lienWaiverPdfPath, Component: LienWaiverRouter },
      { path: finishScheduleVisualModePdfPath, Component: FinishScheduleVisualModePdf },
      { path: projectFinishScheduleVisualModePdfPath, Component: ProjectFinishScheduleVisualModePdf },
      { path: projectFinishSchedulePdfPath, Component: ProjectFinishSchedulePdf },
      { path: tradesPunchlistPdfPath, Component: TradesPunchlistPdf },
      { path: "/pdf/*", Component: NotFound },
    ],
  },
];
